/***********************************************************************
Use            : To declare the application navigation menus
Created By     : ATP-0000850
Created Date   : 22-APR-2020
Updated By     : ATP-0000850
Updated Date   : 22-APR-2020
***********************************************************************/

/** Technical Report Left Navigation */
const technicalReportSections = {
    "properties": {
        "summary": {
            "title": "Summary",
            "x-class": "project"
        },
        "performance": {
            "title": "Project Performance",
            "x-class": "project-timeline"
        },
        "impact": {
            "title": "Project Impact",
            "x-class": "financial-info"
        },
        "documents": {
            "title": "Documents",
            "x-class": "logical-framework"
        }
    }
};

/** */
const adminDashboardSections = {
    "properties": {
        "summary": {
            "title": "Summary",
            "x-class": "project"
        },
        "reviews": {
            "title": "Reviews",
            "x-class": "project-timeline"
        },
        "activityLog": {
            "title": "Activity Log",
            "x-class": "financial-info"
        },
        "documents": {
            "title": "Documents",
            "x-class": "logical-framework"
        }
    }
};
const migratedAdminDashboardSections = {
    "properties": {
        "summary": {
            "title": "Summary",
            "x-class": "project"
        },
        "documents": {
            "title": "Documents",
            "x-class": "logical-framework"
        }
    }
};

/** financial Report Left Navigation */
const financialReportSections = {
    "properties": {
        "summary": {
            "title": "Summary",
            "x-class": "project"
        },
        "transactions": {
            "title": "Transactions",
            "x-class": "transactions project-timeline"
        },
        "personnelCosts": {
            "title": "Personnel Costs",
            "x-class": "personnel-costs financial-info"
        },
        // "financialReport": {
        //     "title": "Financial Report",
        //     "x-class": "financial-report project-desc"
        // },
        "forecast": {
            "title": "Forecast",
            "x-class": "forecast logical-framework"
        },
        "finDocs": {
            "title": "Documents",
            "x-class": "finDocs project-desc"
        }
    }
};

export class AppMenus {
    public static get technicalReportSections() {
        return technicalReportSections;
    }
    public static get financialReportSections() {
        return financialReportSections;
    }
    public static get adminDashboardSections() {
        return adminDashboardSections;
    }
    public static get migratedAdminDashboardSections()
    {
        return migratedAdminDashboardSections;
    }
}